import React, { useState } from 'react';
import { Shield, Mail, User, Key } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const SystemSetup = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    full_name: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { initializeSystem } = useAuth();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!formData.email || !formData.password || !formData.full_name) {
      setError('Alle felter er påkrevd');
      setLoading(false);
      return;
    }

    if (formData.password.length < 6) {
      setError('Passord må være minst 6 tegn');
      setLoading(false);
      return;
    }

    const result = await initializeSystem(formData);
    
    if (!result.success) {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto h-16 w-16 bg-yellow-500 rounded-full flex items-center justify-center">
            <Shield className="h-8 w-8 text-gray-900" />
          </div>
          <h2 className="mt-6 text-3xl font-bold text-white">
            Aktivlogg Oppsett
          </h2>
          <p className="mt-2 text-gray-400">
            Opprett den første super-administrator kontoen
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label htmlFor="full_name" className="block text-sm font-medium text-gray-300">
                Fullt navn
              </label>
              <div className="mt-1 relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
                  <User className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  id="full_name"
                  name="full_name"
                  type="text"
                  required
                  value={formData.full_name}
                  onChange={handleChange}
                  className="appearance-none relative block w-full px-10 py-3 border border-gray-600 placeholder-gray-400 text-white bg-gray-700 rounded-md focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 focus:z-10 sm:text-sm"
                  placeholder="Skriv inn ditt fulle navn"
                />
              </div>
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-300">
                E-post adresse
              </label>
              <div className="mt-1 relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
                  <Mail className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="appearance-none relative block w-full px-10 py-3 border border-gray-600 placeholder-gray-400 text-white bg-gray-700 rounded-md focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 focus:z-10 sm:text-sm"
                  placeholder="admin@aktivlogg.no"
                />
              </div>
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-300">
                Passord
              </label>
              <div className="mt-1 relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
                  <Key className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  id="password"
                  name="password"
                  type="password"
                  required
                  value={formData.password}
                  onChange={handleChange}
                  className="appearance-none relative block w-full px-10 py-3 border border-gray-600 placeholder-gray-400 text-white bg-gray-700 rounded-md focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 focus:z-10 sm:text-sm"
                  placeholder="Minst 6 tegn"
                />
              </div>
            </div>
          </div>

          {error && (
            <div className="bg-red-600/20 border border-red-600/50 rounded-md p-4">
              <p className="text-red-400 text-sm">{error}</p>
            </div>
          )}

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-gray-900 bg-yellow-500 hover:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Oppretter...' : 'Opprett Super Admin'}
            </button>
          </div>

          <div className="bg-blue-600/20 border border-blue-600/50 rounded-md p-4">
            <h3 className="text-blue-400 font-medium mb-2">Hva skjer nå?</h3>
            <ul className="text-blue-300 text-sm space-y-1">
              <li>• Du blir den første super-administratoren</li>
              <li>• Du kan administrere alle organisasjoner i systemet</li>
              <li>• Du kan opprette nye organisasjoner og administratorer</li>
              <li>• En demo-organisasjon (SVPK) blir opprettet automatisk</li>
            </ul>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SystemSetup;